// app/javascript/controllers/modal_controller.js
import { Controller } from "@hotwired/stimulus"

// Shows the overlay when its turbo-frame loads creator content; closes on
// backdrop click, close button, or Escape, emptying the frame.
export default class extends Controller {
  static targets = ["overlay", "frame"]

  connect() {
    this._onLoad = () => { if (this.frameTarget.innerHTML.trim()) this.open() }
    this.frameTarget.addEventListener("turbo:frame-load", this._onLoad)
    // An action taken inside the frame (Hide, Mailed, a note) changes the
    // row behind it: closing then reloads the list.
    this._onSubmit = (e) => { if (e.detail.success) this.changed = true }
    this.frameTarget.addEventListener("turbo:submit-end", this._onSubmit)
    this._onKey = (e) => { if (e.key === "Escape") this.close() }
    document.addEventListener("keydown", this._onKey)
  }

  disconnect() {
    this.frameTarget.removeEventListener("turbo:frame-load", this._onLoad)
    this.frameTarget.removeEventListener("turbo:submit-end", this._onSubmit)
    document.removeEventListener("keydown", this._onKey)
  }

  open() { this.overlayTarget.classList.remove("hidden") }

  // Loads the clicked row's data-url into the frame; turbo:frame-load then
  // opens the overlay. Real links and buttons inside the row (Log in as)
  // keep handling their own click.
  show(event) {
    if (event.target.closest("a, button, form")) return
    const url = event.currentTarget.dataset.url
    if (url) this.frameTarget.src = url
  }

  // The right panel (.admin-drawer) slides out first; a modal just goes.
  close() {
    const overlay = this.overlayTarget
    if (overlay.classList.contains("hidden") || overlay.classList.contains("closing")) return
    if (!overlay.classList.contains("admin-drawer")) return this.finishClose()
    overlay.classList.add("closing")
    setTimeout(() => this.finishClose(), 170)
  }

  finishClose() {
    this.overlayTarget.classList.add("hidden")
    this.overlayTarget.classList.remove("closing")
    this.frameTarget.removeAttribute("src")
    this.frameTarget.innerHTML = ""
    if (this.changed) { this.changed = false; window.Turbo?.visit(window.location.href, { action: "replace" }) }
  }

  backdrop(event) { if (event.target === this.overlayTarget) this.close() }
}
